<dl class="cl-dl it-dl-checkbox">
  <dt>
    <div class="form-check cl-spacing-none">
      <input
        [id]="checkboxId"
        [disabled]="disabled"
        [ngModel]="checked"
        [class.invalid]="invalid"
        (ngModelChange)="onCheckedChange($event)"
        [attr.aria-invalid]="invalid || null"
        class="form-check-input it-dl-checkbox-input"
        type="checkbox"
      >
      <label class="form-check-label" [class.invalid]="invalid" [for]="checkboxId">
        {{ label }} 
        @if (required) {
          <span class="required">*</span>
        }
      </label>
    </div>
  </dt>
  <dd [class.cl-faded]="inactive" class="it-dl-checkbox-details">
    <p>{{ description }}</p>
    <ng-content></ng-content>
  </dd>
</dl>
